import _Promise from "@babel/runtime-corejs2/core-js/promise";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";
import _Symbol from "@babel/runtime-corejs2/core-js/symbol";
import _Symbol$iterator from "@babel/runtime-corejs2/core-js/symbol/iterator";
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
export var yn = ['MAX_TEXTURE_MAX_ANISOTROPY_EXT', 'FRAGMENT_SHADER_DERIVATIVE_HINT_OES', 'MAX_COLOR_ATTACHMENTS_WEBGL', 'MAX_DRAW_BUFFERS_WEBGL', 'DRAW_BUFFER0_WEBGL', 'DRAW_BUFFER1_WEBGL', 'VERTEX_ARRAY_BINDING_OES', 'TIMESTAMP_EXT', 'GPU_DISJOINT_EXT', 'MAX_VIEWS_OVR'];
export var kn = [10752, 2849, 2884, 2885, 2886, 2928, 2929, 2930, 2931, 2932, 2960, 2961, 2962, 2963, 2964, 2965, 2966, 2967, 2968, 2978, 3024, 3042, 3088, 3089, 3106, 3107, 32773, 32777, 32777, 32823, 32824, 32926, 32928, 32936, 32937, 32938, 32939, 32968, 32969, 32970, 32971, 3317, 33170, 3333, 3379, 3386, 33901, 33902, 34016, 34024, 34076, 3408, 3410, 3411, 3412, 3413, 3414, 3415, 34467, 34816, 34817, 34818, 34819, 34877, 34921, 34930, 35660, 35661, 35724, 35738, 35739, 36003, 36004, 36005, 36347, 36348, 36349, 37440, 37441, 37443, 7936, 7937, 7938];
export var En = ['FRAGMENT_SHADER', 'VERTEX_SHADER'];
export var Rn = ['LOW_FLOAT', 'MEDIUM_FLOAT', 'HIGH_FLOAT', 'LOW_INT', 'MEDIUM_INT', 'HIGH_INT'];
export var b = function b(e) {
  return e.reduce(function (e, t) {
    return e + (t ? 1 : 0);
  }, 0);
};
export var v = function v(e, t) {
  return new _Promise(function (n) {
    return setTimeout(n, e, t);
  });
};
export var E = function E() {
  var e = window,
      t = navigator;
  return b(['ApplePayError' in e, 'CSSPrimitiveValue' in e, 'Counter' in e, 0 === t.vendor.indexOf('Apple'), 'getStorageUpdates' in t, 'WebKitMediaKeys' in e]) >= 4;
};
export var n = function n(e, t) {
  var n = {};

  for (var r in e) {
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  }

  if (null != e && 'function' == typeof _Object$getOwnPropertySymbols) {
    var i = 0;

    for (r = _Object$getOwnPropertySymbols(e); i < r.length; i++) {
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
    }
  }

  return n;
};
export function r(e, t, n, r) {
  return new (n || (n = _Promise))(function (i, o) {
    function a(e) {
      try {
        s(r.next(e));
      } catch (t) {
        o(t);
      }
    }

    function u(e) {
      try {
        s(r.throw(e));
      } catch (t) {
        o(t);
      }
    }

    function s(e) {
      var t;
      e.done ? i(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
        e(t);
      })).then(a, u);
    }

    s((r = r.apply(e, t || [])).next());
  });
}
export function i(e, t) {
  var n,
      r,
      i,
      o,
      a = {
    label: 0,
    sent: function sent() {
      if (1 & i[0]) throw i[1];
      return i[1];
    },
    trys: [],
    ops: []
  };
  return o = {
    next: u(0),
    throw: u(1),
    return: u(2)
  }, 'function' == typeof _Symbol && (o[_Symbol$iterator] = function () {
    return this;
  }), o;

  function u(o) {
    return function (u) {
      return function (o) {
        if (n) throw new TypeError('Generator is already executing.');

        for (; a;) {
          try {
            if (n = 1, r && (i = 2 & o[0] ? r.return : o[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, o[1])).done) return i;

            switch (r = 0, i && (o = [2 & o[0], i.value]), o[0]) {
              case 0:
              case 1:
                i = o;
                break;

              case 4:
                return a.label++, {
                  value: o[1],
                  done: !1
                };

              case 5:
                a.label++, r = o[1], o = [0];
                continue;

              case 7:
                ;
                o = a.ops.pop(), a.trys.pop();
                continue;

              default:
                if (!(i = a.trys, (i = i.length > 0 && i[i.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                  a = 0;
                  continue;
                }

                if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                  a.label = o[1];
                  break;
                }

                if (6 === o[0] && a.label < i[1]) {
                  ;
                  a.label = i[1], i = o;
                  break;
                }

                if (i && a.label < i[2]) {
                  ;
                  a.label = i[2], a.ops.push(o);
                  break;
                }

                i[2] && a.ops.pop(), a.trys.pop();
                continue;
            }

            o = t.call(e, a);
          } catch (u) {
            ;
            o = [6, u], r = 0;
          } finally {
            n = i = 0;
          }
        }

        if (5 & o[0]) throw o[1];
        return {
          value: o[0] ? o[1] : void 0,
          done: !0
        };
      }([o, u]);
    };
  }
}
export function o() {
  for (var e = 0, t = 0, n = arguments.length; t < n; t++) {
    e += arguments[t].length;
  }

  var r = Array(e),
      i = 0;

  for (t = 0; t < n; t++) {
    for (var o = arguments[t], a = 0, u = o.length; a < u; a++, i++) {
      r[i] = o[a];
    }
  }

  return r;
}
export function a(e, t) {
  ;
  e = [e[0] >>> 16, 65535 & e[0], e[1] >>> 16, 65535 & e[1]], t = [t[0] >>> 16, 65535 & t[0], t[1] >>> 16, 65535 & t[1]];
  var n = [0, 0, 0, 0];
  return n[3] += e[3] + t[3], n[2] += n[3] >>> 16, n[3] &= 65535, n[2] += e[2] + t[2], n[1] += n[2] >>> 16, n[2] &= 65535, n[1] += e[1] + t[1], n[0] += n[1] >>> 16, n[1] &= 65535, n[0] += e[0] + t[0], n[0] &= 65535, [n[0] << 16 | n[1], n[2] << 16 | n[3]];
}
export function u(e, t) {
  ;
  e = [e[0] >>> 16, 65535 & e[0], e[1] >>> 16, 65535 & e[1]], t = [t[0] >>> 16, 65535 & t[0], t[1] >>> 16, 65535 & t[1]];
  var n = [0, 0, 0, 0];
  return n[3] += e[3] * t[3], n[2] += n[3] >>> 16, n[3] &= 65535, n[2] += e[2] * t[3], n[1] += n[2] >>> 16, n[2] &= 65535, n[2] += e[3] * t[2], n[1] += n[2] >>> 16, n[2] &= 65535, n[1] += e[1] * t[3], n[0] += n[1] >>> 16, n[1] &= 65535, n[1] += e[2] * t[2], n[0] += n[1] >>> 16, n[1] &= 65535, n[1] += e[3] * t[1], n[0] += n[1] >>> 16, n[1] &= 65535, n[0] += e[0] * t[3] + e[1] * t[2] + e[2] * t[1] + e[3] * t[0], n[0] &= 65535, [n[0] << 16 | n[1], n[2] << 16 | n[3]];
}
export function s(e, t) {
  return 32 === (t %= 64) ? [e[1], e[0]] : t < 32 ? [e[0] << t | e[1] >>> 32 - t, e[1] << t | e[0] >>> 32 - t] : (t -= 32, [e[1] << t | e[0] >>> 32 - t, e[0] << t | e[1] >>> 32 - t]);
}
export function c(e, t) {
  return 0 === (t %= 64) ? e : t < 32 ? [e[0] << t | e[1] >>> 32 - t, e[1] << t] : [e[1] << t - 32, 0];
}
export function l(e, t) {
  return [e[0] ^ t[0], e[1] ^ t[1]];
}
export function d(e) {
  return e = l(e, [0, e[0] >>> 1]), e = l(e = u(e, [4283543511, 3981806797]), [0, e[0] >>> 1]), e = l(e = u(e, [3301882366, 444984403]), [0, e[0] >>> 1]);
}
export function f(e, t) {
  t = t || 0;
  var n,
      r = (e = e || '').length % 16,
      i = e.length - r,
      o = [0, t],
      f = [0, t],
      v = [0, 0],
      h = [0, 0],
      p = [2277735313, 289559509],
      m = [1291169091, 658871167];

  for (n = 0; n < i; n += 16) {
    v = [255 & e.charCodeAt(n + 4) | (255 & e.charCodeAt(n + 5)) << 8 | (255 & e.charCodeAt(n + 6)) << 16 | (255 & e.charCodeAt(n + 7)) << 24, 255 & e.charCodeAt(n) | (255 & e.charCodeAt(n + 1)) << 8 | (255 & e.charCodeAt(n + 2)) << 16 | (255 & e.charCodeAt(n + 3)) << 24], h = [255 & e.charCodeAt(n + 12) | (255 & e.charCodeAt(n + 13)) << 8 | (255 & e.charCodeAt(n + 14)) << 16 | (255 & e.charCodeAt(n + 15)) << 24, 255 & e.charCodeAt(n + 8) | (255 & e.charCodeAt(n + 9)) << 8 | (255 & e.charCodeAt(n + 10)) << 16 | (255 & e.charCodeAt(n + 11)) << 24], v = s(v = u(v, p), 31), o = a(o = s(o = l(o, v = u(v, m)), 27), f), o = a(u(o, [0, 5]), [0, 1390208809]), h = s(h = u(h, m), 33), f = a(f = s(f = l(f, h = u(h, p)), 31), o), f = a(u(f, [0, 5]), [0, 944331445]);
  }

  switch (v = [0, 0], h = [0, 0], r) {
    case 15:
      h = l(h, c([0, e.charCodeAt(n + 14)], 48));

    case 14:
      h = l(h, c([0, e.charCodeAt(n + 13)], 40));

    case 13:
      h = l(h, c([0, e.charCodeAt(n + 12)], 32));

    case 12:
      h = l(h, c([0, e.charCodeAt(n + 11)], 24));

    case 11:
      h = l(h, c([0, e.charCodeAt(n + 10)], 16));

    case 10:
      h = l(h, c([0, e.charCodeAt(n + 9)], 8));

    case 9:
      ;
      h = u(h = l(h, [0, e.charCodeAt(n + 8)]), m), f = l(f, h = u(h = s(h, 33), p));

    case 8:
      v = l(v, c([0, e.charCodeAt(n + 7)], 56));

    case 7:
      v = l(v, c([0, e.charCodeAt(n + 6)], 48));

    case 6:
      v = l(v, c([0, e.charCodeAt(n + 5)], 40));

    case 5:
      v = l(v, c([0, e.charCodeAt(n + 4)], 32));

    case 4:
      v = l(v, c([0, e.charCodeAt(n + 3)], 24));

    case 3:
      v = l(v, c([0, e.charCodeAt(n + 2)], 16));

    case 2:
      v = l(v, c([0, e.charCodeAt(n + 1)], 8));

    case 1:
      ;
      v = u(v = l(v, [0, e.charCodeAt(n)]), p), o = l(o, v = u(v = s(v, 31), m));
  }

  return o = a(o = l(o, [0, e.length]), f = l(f, [0, e.length])), f = a(f, o), o = a(o = d(o), f = d(f)), f = a(f, o), ('00000000' + (o[0] >>> 0).toString(16)).slice(-8) + ('00000000' + (o[1] >>> 0).toString(16)).slice(-8) + ('00000000' + (f[0] >>> 0).toString(16)).slice(-8) + ('00000000' + (f[1] >>> 0).toString(16)).slice(-8);
}
export function Sn(e) {
  return 'string' == typeof e && !e.match(/[^A-Z0-9_x]/);
}
export function Tn(e) {
  return _Object$keys(e.__proto__).filter(Sn);
}
export function _n(e, t, n) {
  var r = e.getShaderPrecisionFormat(e[t], e[n]);
  return r ? [r.rangeMin, r.rangeMax, r.precision] : [];
}
export function Pe(e, t) {
  return new _Promise(function (n) {
    return setTimeout(n, e, t);
  });
}
export function Ne(e, t) {
  var n = this;
  return new _Promise(function (o, a) {
    var u = t(),
        s = !1;
    null == e || e.then(o, a).then(function () {
      return s = !0;
    });

    var c = function c(e) {
      return r(n, void 0, void 0, function () {
        var t, n;
        return i(this, function (r) {
          switch (r.label) {
            case 0:
              if (e.done) return [2, o(e.value)];
              r.label = 1;

            case 1:
              return r.trys.push([1, 3,, 4]), [4, e.value];

            case 2:
              if (t = r.sent(), !s) try {
                c(u.next(t));
              } catch (i) {
                a(i);
              }
              return [3, 4];

            case 3:
              if (n = r.sent(), !s) try {
                c(u.throw(n));
              } catch (i) {
                a(i);
              }
              return [3, 4];

            case 4:
              return [2];
          }
        });
      });
    };

    c(u.next());
  });
}